import { render } from "./TrafficWidget.vue?vue&type=template&id=83b37074"
import script from "./TrafficWidget.vue?vue&type=script&lang=js"
export * from "./TrafficWidget.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__